const LOADER_FADE_MS = 400;
const MAX_WAIT_MS = 4000;

function isVideoReady(video) {
  return video.readyState >= 2;
}

function nudgeVideoPlay(video) {
  if (!video || typeof video.play !== "function") return;
  const attempt = video.play();
  if (attempt && typeof attempt.catch === "function") {
    attempt.catch(() => {});
  }
}

function waitForHeroMedia(hero) {
  const video = hero.querySelector(".hero-bg-video");
  const img = hero.querySelector(".hero-bg-img");

  if (video) {
    if (isVideoReady(video)) return Promise.resolve();

    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve();
      };

      const cleanup = () => {
        video.removeEventListener("loadeddata", finish);
        video.removeEventListener("canplay", finish);
        video.removeEventListener("playing", finish);
        video.removeEventListener("error", finish);
      };

      video.addEventListener("loadeddata", finish, { once: true });
      video.addEventListener("canplay", finish, { once: true });
      video.addEventListener("playing", finish, { once: true });
      video.addEventListener("error", finish, { once: true });

      nudgeVideoPlay(video);

      if (video.networkState === video.NETWORK_EMPTY) {
        video.load();
      }
    });
  }

  if (!img) return Promise.resolve();
  if (img.complete && img.naturalWidth > 0) return Promise.resolve();

  return new Promise((resolve) => {
    img.addEventListener("load", resolve, { once: true });
    img.addEventListener("error", resolve, { once: true });
  });
}

function waitForFonts() {
  if (document.fonts && typeof document.fonts.ready?.then === "function") {
    return document.fonts.ready;
  }
  return Promise.resolve();
}

function unlockScroll() {
  document.documentElement.classList.remove("has-hero-loader");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("width");
}

function revealHero(hero, loader) {
  const video = hero.querySelector(".hero-bg-video");
  nudgeVideoPlay(video);

  hero.classList.add("is-hero-ready");

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.documentElement.classList.add("is-app-ready");
      unlockScroll();

      if (!loader) return;

      const removeLoader = () => loader.remove();
      loader.addEventListener("transitionend", removeLoader, { once: true });
      window.setTimeout(removeLoader, LOADER_FADE_MS + 100);
    });
  });
}

export function initHeroLoader() {
  const hero = document.querySelector(".hero-clip");
  const loader = document.querySelector(".site-loader");

  if (!hero) {
    document.documentElement.classList.add("is-app-ready");
    unlockScroll();
    loader?.remove();
    return Promise.resolve();
  }

  document.documentElement.classList.add("has-hero-loader");

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reducedMotion) {
    revealHero(hero, loader);
    return Promise.resolve();
  }

  return Promise.race([
    Promise.all([waitForHeroMedia(hero), waitForFonts()]),
    new Promise((resolve) => window.setTimeout(resolve, MAX_WAIT_MS)),
  ]).then(() => {
    revealHero(hero, loader);
  });
}
